import { queryOptions, useQuery } from '@tanstack/react-query'

import { userApi } from '../api/userApi'

const getUserByUpdateParametersTokenQueryOptions = ({ token, enabled }: { token: string; enabled: boolean }) =>
  queryOptions({
    queryKey: ['user', token],
    queryFn: ({ signal }) => userApi.getUserByUpdateParametersToken(token, { signal }),
    enabled,
  })

export const useUserByUpdateParametersTokenQuery = (settings: { token: string; enabled: boolean }) =>
  useQuery(getUserByUpdateParametersTokenQueryOptions(settings))
